import {useBaseStore} from "~/stores/base";
import sha1 from "js-sha1"
import {v4 as uuidv4} from 'uuid';

// 需求来源：BNTO-2876
// 文档原文：https://docs.google.com/document/d/1rRiRHAt8_TgJIGgLLM-8nWXoGC_ncxPj4PlhWe8ML-w/edit?tab=t.0
// 文档翻译：https://mobiverse.feishu.cn/docx/YlMydoZ4JorCoRx1cvTc2AEwnPf
export default defineNuxtPlugin(() => {
  const script = document.createElement('script');
  script.src = 'https://utt.impactcdn.com/A6260562-27cc-4665-88b3-3c80e0afb5691.js'; // 替换为你项目的 JS 链接
  script.async = true;
  document.head.appendChild(script);
  script.onload = () => {
    // 确保脚本已加载完毕后再调用
    if (window.ire) {
      impactIdentify()
    } else {
      console.error('window.ire 未定义');
    }
  };
});

const impactIdentify = () => {
  const ire = window.ire
  const isLogin = useBaseStore().getterIsLogin
  const params = {
    customerId: isLogin ? useBaseStore().getterUserInfo.userId : "",
    customerEmail: isLogin ? sha1(useBaseStore().getterUserInfo.email) : "",
    customProfileId: uuidv4()
  }
  ire('identify', params);
  console.log("[impact identified]", params)
}
